import { render, staticRenderFns } from "./InputNumberElement.vue?vue&type=template&id=33f4e80e&scoped=true"
import script from "./InputNumberElement.vue?vue&type=script&lang=js"
export * from "./InputNumberElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4e80e",
  null
  
)

export default component.exports